import React from 'react';
import { PiSpinnerGap } from 'react-icons/pi';

/**
 * Button — универсальная кнопка BetMate.
 *
 * @param {'primary'|'secondary'|'ghost'|'danger'|'success'} variant
 * @param {'sm'|'md'|'lg'} size
 * @param {boolean} loading
 * @param {boolean} disabled
 * @param {React.ReactNode} icon — иконка слева
 * @param {string} className — дополнительные классы
 */
const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  icon,
  className = '',
  type = 'button',
  onClick,
  ...rest
}) => {
  const classes = [
    'bm-btn',
    `bm-btn--${variant}`,
    `bm-btn--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      {...rest}
    >
      {loading ? (
        <PiSpinnerGap className="bm-spin" size={16} />
      ) : (
        icon && <span className="bm-btn__icon">{icon}</span>
      )}
      {children}
    </button>
  );
};

export default Button;
